<template>
  <div>
    <div v-if="!showDashboard">
      <div class="mb-5 mt-3">
        <div class="col-12 text-center">
          <img src="/img/selo-color.svg" height="150" />
        </div>
      </div>
      <div class="row p-2 pt-5">
        <div class="col-md-12 col-sm-12">
          <ValidationObserver ref="dados" class="w-100">
            <form>
              <div class="mb-2">
                <ValidationProvider name="senha" rules="required" mode="passive" v-slot="{ errors, classes }">
                  <div class="field">
                    <input :type="showPassword ? 'text' : 'password'" class="input" :style="senha && 'color: black'"
                      :class="classes" v-model="senha" @focus="clear" maxlength="100" autocomplete="nope" />
                    <label :class="senha && 'filled'">Digite sua senha</label>
                    <img class="hide-show" @click="togglePasswordVisibility"
                      :src="showPassword ? '/img/eye-closed.svg' : '/img/eye-open.svg'" />
                    <span class="invalid-feedback">{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </div>
            </form>
          </ValidationObserver>
          <button class="continue-btn mt-5" :disabled="loading" @click.prevent="handle">
            <span>ENTRAR</span>
          </button>
        </div>


      </div>
      <vue-bottom-sheet-vue2 ref="warning" drag-color="rgba(255, 255, 255, 0.5)">
        <div class="text-center pb-5">
          <h5 class="text-info">Não foi possivel enviar as informações</h5>
        </div>
      </vue-bottom-sheet-vue2>
      <vue-bottom-sheet-vue2 ref="notauth" drag-color="rgba(255, 255, 255, 0.5)">
        <div class="text-center pb-5">
          <h5 class="text-info">Acesso não autorizado</h5>
        </div>
      </vue-bottom-sheet-vue2>

      <vue-bottom-sheet-vue2 ref="required" drag-color="rgba(255, 255, 255, 0.5)">
        <div class="text-center pb-5">
          <h5 class="text-info">Escolha uma das opções</h5>
        </div>
      </vue-bottom-sheet-vue2>
    </div>
    <div v-else>
      <iframe class="embed-fullscreen"
        src="https://metabase.beachd.com.br/public/dashboard/d7b379e0-e185-416d-ad1f-3bc2973614d4"
        @load="onEmbedLoaded"></iframe>
      <button class="floating-exit-btn" @click="logout">Sair</button>
    </div>
    <Loading v-if="loading" />
  </div>
</template>

<script>

import VueBottomSheetVue2 from "@webzlodimir/vue-bottom-sheet-vue2";
import config from "../config";

export default {
  components: {
    VueBottomSheetVue2,
    Loading: () => import("./Loading.vue"),
  },
  data() {
    return {
      senha: undefined,
      showPassword: false,
      config,
      loading: false,
      idUsuario: undefined,
      showDashboard: false,
    };
  },
  created() {
    const idUsuario = window.sessionStorage.getItem("idUsuario");

    if (idUsuario === null || idUsuario === undefined || idUsuario === "undefined" || idUsuario === "") {
      this.showDashboard = false;
    } else {
      const parsedIdCliente = JSON.parse(idUsuario);
      this.idUsuario = parsedIdCliente;
      this.showDashboard = true;
    }
  },
  mounted() {
  },
  watch: {
  },
  methods: {
    onEmbedLoaded() {
      this.loading = false; // Exemplo: mostrar um indicador de carregamento
    },
    logout() {
      window.sessionStorage.removeItem("idUsuario"); // Remove o ID do usuário da sessão
      this.showDashboard = false; // Redireciona para a página inicial
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },

    clear() {
      this.$nextTick(() => {
        this.$refs.dados.reset();
      });
    },

    async handle() {
      const valid = await this.$refs.dados.validate();
      if (!valid) return;

      this.loading = true;

      const correctHash = "e10adc3949ba59abbe56e057f20f883e"; // Exemplo de hash MD5

      const inputHash = this.hashPassword(this.senha);

      if (inputHash === correctHash) {
        this.idUsuario = JSON.stringify("f695179b-6ab2-450c-8425-39beef070eed");
        window.sessionStorage.setItem("idUsuario", this.idUsuario);
        this.showDashboard = true;
      } else {
        this.loading = false;
        this.$refs.notauth.open(); // Exibe mensagem de erro
      }
    },
    hashPassword(password) {
      const cripto = require("crypto").createHash("md5").update(password).digest("hex");
      return cripto;
    },

  },
};
</script>
<style scoped>
.floating-exit-btn {
  position: fixed;
  bottom: 20px;
  /* Distância do botão em relação à parte inferior da tela */
  right: 20px;
  /* Distância do botão em relação à lateral direita */
  background-color: #0D4275;
  /* Cor de fundo do botão */
  color: white;
  /* Cor do texto */
  border: none;
  /* Remove bordas */
  border-radius: 50px;
  /* Deixa o botão arredondado */
  padding: 10px 20px;
  /* Espaçamento interno */
  font-size: 16px;
  /* Tamanho da fonte */
  cursor: pointer;
  /* Mostra o cursor de "mão" ao passar sobre o botão */
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  /* Adiciona uma sombra ao botão */
  transition: background-color 0.3s ease;
  /* Animação para mudança de cor */
}

.floating-exit-btn:hover {
  background-color: #BCE0FD;
  /* Cor ao passar o mouse */
}

.embed-fullscreen {
  width: 100%;
  height: 100vh;
  /* Ocupa toda a altura da janela */
  border: none;
  /* Remove bordas, se houver */
  display: block;
  /* Garante que o elemento seja exibido como bloco */
  margin: 0;
  /* Remove margens */
  padding: 0;
  /* Remove preenchimentos */
}

.hide-show {
  position: absolute;
  right: 15px;
  top: 22px;
  transition: 0.2s ease all;
  cursor: pointer;
}
</style>
